// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.time-picker-wrapper {
  position: relative;
  display: inline-block;
  min-height: 28px;
}

.time-picker-display {
  padding: 8px 12px;
  border: 1px solid #ccc;
  border-radius: 4px;
  cursor: pointer;
  min-width: 80px;
  text-align: left;
  -webkit-user-select: none;
          user-select: none;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.time-picker-display.disabled {
  background-color: #e0e0e0;
  color: #6b6a6a;
  cursor: not-allowed;
  border-color: #b0b0b0;
}

.display-value-text {
  flex-grow: 1;
  text-align: left;
}

/* Clear Button Styling */
.clear-button {
  margin-left: 10px; /* ระยะห่างจากข้อความ */
  font-size: 1.5em; /* ขนาดไอคอน */
  color: #dc3545; /* สีแดง */
  cursor: pointer;
  line-height: 1; /* จัดตำแหน่งแนวตั้งของ X */
}

.clear-button:hover {
  color: #a71d2a; /* สีแดงเข้มขึ้นเมื่อ hover */
}

.clear-button.disabled-clear {
  color: #a0a0a0; /* สีเทาเมื่อ disabled */
  cursor: not-allowed;
}

.time-picker-popup {
  position: absolute;
  top: 100%;
  left: 0;
  z-index: 1000;
  background-color: #fff;
  border: 1px solid #ddd;
  border-radius: 4px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  padding: 10px;
  margin-top: 5px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.time-picker-controls {
  display: flex;
  gap: 5px;
  align-items: center;
}

.time-picker-controls select {
  padding: 5px;
  border-radius: 4px;
  border: 1px solid #ccc;
}

.time-picker-controls select[disabled] {
  background-color: #eee;
  cursor: not-allowed;
  opacity: 0.7;
}

.time-picker-actions {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  margin-top: 5px;
}

.time-picker-actions button {
  padding: 6px 12px;
  border: none;
  border-radius: 4px;
  /* cursor: pointer; */
  /* background-color: #007bff; */
  /* color: white; */
  font-size: 0.9em;
}

.time-picker-actions button:hover {
  background-color: #0056b3;
}

.time-picker-actions button[disabled] {
  background-color: #cccccc;
  cursor: not-allowed;
  opacity: 0.7;
}

.time-picker-actions button:last-child {
  background-color: #989da1;
}

.time-picker-actions button:last-child:hover {
  background-color: #7a8187;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/ui/forms/inputs/oops-gem-timepicker/oops-gem-timepicker.component.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,yBAAiB;UAAjB,iBAAiB;EACjB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA,yBAAyB;AACzB;EACE,iBAAiB,EAAE,uBAAuB;EAC1C,gBAAgB,EAAE,cAAc;EAChC,cAAc,EAAE,UAAU;EAC1B,eAAe;EACf,cAAc,EAAE,2BAA2B;AAC7C;;AAEA;EACE,cAAc,EAAE,6BAA6B;AAC/C;;AAEA;EACE,cAAc,EAAE,wBAAwB;EACxC,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,aAAa;EACb,sBAAsB;EACtB,sBAAsB;EACtB,kBAAkB;EAClB,wCAAwC;EACxC,aAAa;EACb,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,qBAAqB;EACrB,+BAA+B;EAC/B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":[".time-picker-wrapper {\r\n  position: relative;\r\n  display: inline-block;\r\n  min-height: 28px;\r\n}\r\n\r\n.time-picker-display {\r\n  padding: 8px 12px;\r\n  border: 1px solid #ccc;\r\n  border-radius: 4px;\r\n  cursor: pointer;\r\n  min-width: 80px;\r\n  text-align: left;\r\n  user-select: none;\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n}\r\n\r\n.time-picker-display.disabled {\r\n  background-color: #e0e0e0;\r\n  color: #6b6a6a;\r\n  cursor: not-allowed;\r\n  border-color: #b0b0b0;\r\n}\r\n\r\n.display-value-text {\r\n  flex-grow: 1;\r\n  text-align: left;\r\n}\r\n\r\n/* Clear Button Styling */\r\n.clear-button {\r\n  margin-left: 10px; /* ระยะห่างจากข้อความ */\r\n  font-size: 1.5em; /* ขนาดไอคอน */\r\n  color: #dc3545; /* สีแดง */\r\n  cursor: pointer;\r\n  line-height: 1; /* จัดตำแหน่งแนวตั้งของ X */\r\n}\r\n\r\n.clear-button:hover {\r\n  color: #a71d2a; /* สีแดงเข้มขึ้นเมื่อ hover */\r\n}\r\n\r\n.clear-button.disabled-clear {\r\n  color: #a0a0a0; /* สีเทาเมื่อ disabled */\r\n  cursor: not-allowed;\r\n}\r\n\r\n.time-picker-popup {\r\n  position: absolute;\r\n  top: 100%;\r\n  left: 0;\r\n  z-index: 1000;\r\n  background-color: #fff;\r\n  border: 1px solid #ddd;\r\n  border-radius: 4px;\r\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\r\n  padding: 10px;\r\n  margin-top: 5px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 10px;\r\n}\r\n\r\n.time-picker-controls {\r\n  display: flex;\r\n  gap: 5px;\r\n  align-items: center;\r\n}\r\n\r\n.time-picker-controls select {\r\n  padding: 5px;\r\n  border-radius: 4px;\r\n  border: 1px solid #ccc;\r\n}\r\n\r\n.time-picker-controls select[disabled] {\r\n  background-color: #eee;\r\n  cursor: not-allowed;\r\n  opacity: 0.7;\r\n}\r\n\r\n.time-picker-actions {\r\n  display: flex;\r\n  justify-content: flex-end;\r\n  gap: 8px;\r\n  margin-top: 5px;\r\n}\r\n\r\n.time-picker-actions button {\r\n  padding: 6px 12px;\r\n  border: none;\r\n  border-radius: 4px;\r\n  /* cursor: pointer; */\r\n  /* background-color: #007bff; */\r\n  /* color: white; */\r\n  font-size: 0.9em;\r\n}\r\n\r\n.time-picker-actions button:hover {\r\n  background-color: #0056b3;\r\n}\r\n\r\n.time-picker-actions button[disabled] {\r\n  background-color: #cccccc;\r\n  cursor: not-allowed;\r\n  opacity: 0.7;\r\n}\r\n\r\n.time-picker-actions button:last-child {\r\n  background-color: #989da1;\r\n}\r\n\r\n.time-picker-actions button:last-child:hover {\r\n  background-color: #7a8187;\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
